/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.company}}</li>
    <li class="w-50 list-item-col">{{Itemize.date_in | formatTimestamp}}-{{Itemize.date_out | formatTimestamp}}</li>
    <li class="w-50 list-item-col">{{Itemize.num}} 人</li>
    <li class="w-50 list-item-col">{{Itemize.time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col"  :class="[$GFUN.FormatColor(Itemize.status)]">{{Itemize.status | formatVar('HOrderStatus')}}</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeHomestay',
    props:{
      Itemize:{}
    },
  }
</script>
